<style type="text/css"></style>

<template>
  <div>
    <div style="font-size: 13px; line-height: 1.3;">
      <div v-html="translate(section.description)"></div>
      <div v-if="section.sectionResources && !section.sectionResources.length" v-html="translate(section.empty)"></div>

      <v-btn
        outlined
        small
        color="grey darken-3"
        v-if="shouldShowSkipBtn"
        data-qa="dialog_resource_add__skip_btn"
        @click="onSkipSection"
        style="margin: 20px 0;"
      >
        {{ translate('ui_skip_btn') }}
      </v-btn>
    </div>

  </div>
</template>

<script>
// mixins
import Mixin from '../../../mixins/mixin';

export default {
  components: {},
  props: {
    section: Object,
  },
  mixins: [Mixin],
  computed: {
    shouldShowSkipBtn() {
      return false;
    },
    index() {
      const sectionId = this.section.id;
      // eslint-disable-next-line
      const sectionIndex = this.$store.state.activeTemplate.data.sections.filter((s) => s.isEnabled).findIndex((s) => s.id === sectionId);
      return sectionIndex + 1;
    },
  },
  methods: {
    onSkipSection() {
      // eslint-disable-next-line
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
      this.$store.dispatch('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isEnabled`,
        value: false,
      });
      this.$store.dispatch('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isInitialized`,
        value: true,
      });
    },
  },
};

</script>
